import { Color } from "molstar/lib/mol-util/color";

export const INTERACTION_COLOR = {
    'π-π interaction': Color.fromRgb(47, 79, 79),
    'Proximal contact': Color.fromRgb(54, 69, 79),
    'H-bond*': Color.fromRgb(75, 0, 130),
    'H-bond': Color.fromRgb(75, 0, 130),
    'Apolar vdW contact': Color.fromRgb(60, 95, 95),
    'CH-O/N bond': Color.fromRgb(173, 216, 230),
    'lp-π interaction': Color.fromRgb(70, 130, 180),
    'Cation-π interaction': Color.fromRgb(0, 255, 255),
    'Clash': Color.fromRgb(139, 0, 0),
    'Salt-bridge': Color.fromRgb(128, 0, 128),
    'Polar vdW contact': Color.fromRgb(255, 0, 127),
    'Water mediated contact': Color.fromRgb(72, 61, 139),
    'Metal mediated contact': Color.fromRgb(139, 69, 19),
    'S-bond': Color.fromRgb(255, 103, 0),
    'S-S Bond': Color.fromRgb(255, 103, 0),
    'Halogen bond': Color.fromRgb(85, 107, 47),
    'Anion-π interaction': Color.fromRgb(255, 0, 255),
    'Amino-π interaction': Color.fromRgb(152, 251, 152),
    'CH-π interaction': Color.fromRgb(34, 139, 34),
    'O/N/SH-π interaction': Color.fromRgb(90, 75, 170),
}

export const INTERACTION_COLOR_HIGHCHART = {
    'π-π interaction': 'rgba(47, 79, 79)',
    'Proximal contact': 'rgba(54, 69, 79)',
    'H-bond*': 'rgba(75, 0, 130)',
    'H-bond': 'rgba(75, 0, 130)',
    'Apolar vdW contact': 'rgba(60, 95, 95)',
    'CH-O/N bond': 'rgba(173, 216, 230)',
    'lp-π interaction': 'rgba(70, 130, 180)',
    'Cation-π interaction': 'rgba(0, 255, 255)',
    'Clash': 'rgba(139, 0, 0)',
    'Salt-bridge': 'rgba(128, 0, 128)',
    'Polar vdW contact': 'rgba(255, 0, 127)',
    'Water mediated contact': 'rgba(72, 61, 139)',
    'Metal mediated contact': 'rgba(139, 69, 19)',
    'S-bond': 'rgba(255, 103, 0)',
    'S-S Bond': 'rgba(255, 103, 0)',
    'Halogen bond': 'rgba(85, 107, 47)',
    'Anion-π interaction': 'rgba(255, 0, 255)',
    'Amino-π interaction': 'rgba(152, 251, 152)',
    'CH-π interaction': 'rgba(34, 139, 34)',
    'O/N/SH-π interaction': 'rgba(90, 75, 170)',
}

export const SYMBOLS_HIGHCHART = {
    'π-π interaction': 'circle',
    'Proximal contact': 'square',
    'H-bond*': 'diamond',
    'H-bond': 'triangle',
    'Apolar vdW contact': 'triangle-down',
    'CH-O/N bond': 'circle',
    'lp-π interaction': 'square',
    'Cation-π interaction': 'triangle',
    'Clash': 'triangle-down',
    'Salt-bridge': 'circle',
    'Polar vdW contact': 'square',
    'Water mediated contact': 'circle',
    'Metal mediated contact': 'square',
    'S-bond': 'triangle',
    'S-S Bond': 'triangle',
    'Halogen bond': 'triangle-down',
    'Anion-π interaction': 'circle',
    'Amino-π interaction': 'diamond',
    'CH-π interaction': 'circle',
    'O/N/SH-π interaction': 'square',
}